import Api from '@/api';

const resetPersistedState = context => new Promise(async (resolve, reject) => {
  try {
    await Promise.all([
      context.dispatch('Appointment/setContact', null),
      context.dispatch('Appointment/resetBookingData'),
      context.dispatch('Appointment/resetDate'),
      context.dispatch('Appointment/resetEmail'),
      context.dispatch('Appointment/resetLocation'),
      context.dispatch('Appointment/resetReachedSummary'),
      context.dispatch('Appointment/resetServices'),
      context.dispatch('Appointment/resetServicesEstimate'),
      context.dispatch('Schedule/setDateFilter'),
      context.dispatch('Schedule/setInspectorFilter'),
      context.dispatch('Schedule/setMonthFilter'),
      context.dispatch('Schedule/setTimeFilter'),
      context.commit('resetStepIndex'),
    ]);
    resolve();
  } catch (err) {
    reject(err);
  }
});

const resetUser = context => new Promise(async (resolve, reject) => {
  try {
    Api.authService.destroyAuthToken();
    await Promise.all([
      context.dispatch('Auth/resetUser'),
      context.dispatch('Appointment/resetEmail'),
    ]);
    resolve();
  } catch (err) {
    reject(err);
  }
});

export default {
  resetPersistedState,
  resetUser,
};
